function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_30-Cash-register",
    "data-name": "30-Cash-register"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,46V19a3,3,0,0,0-3-3H45V12h6a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H33a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h6v4H25V8a1,1,0,0,0-.62-.92,1,1,0,0,0-1.09.21L21,9.59l-2.29-2.3a1,1,0,0,0-1.42,0L15,9.59l-2.29-2.3a1,1,0,0,0-1.09-.21A1,1,0,0,0,11,8v8H8a3,3,0,0,0-3,3v4a1,1,0,0,0,2,0V19a1,1,0,0,1,1-1h3V30H10a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2H25V18H56a1,1,0,0,1,1,1V46H50a1,1,0,0,0,0,2h9a1,1,0,0,1,1,1V59a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V49a1,1,0,0,1,1-1H46a1,1,0,0,0,0-2H7V27a1,1,0,0,0-2,0V46a3,3,0,0,0-3,3V59a3,3,0,0,0,3,3H59a3,3,0,0,0,3-3V49A3,3,0,0,0,59,46ZM13,30V10.41l1.29,1.3a1,1,0,0,0,1.42,0L18,9.41l2.29,2.3a1,1,0,0,0,1.42,0L23,10.41V30ZM34,4H50v6H34Zm7,8h2v4H41Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,23a1,1,0,0,0-1-1H31a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H53a1,1,0,0,0,1-1Zm-2,7H32V24H52Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,35H49a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,40H49a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,35H40a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,40H40a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,37h4a1,1,0,0,0,0-2H31a1,1,0,0,0,0,2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,42h4a1,1,0,0,0,0-2H31a1,1,0,0,0,0,2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,54a3,3,0,1,0-3,3A3,3,0,0,0,57,54Zm-4,0a1,1,0,1,1,1,1A1,1,0,0,1,53,54Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,53a1,1,0,0,0,0,2H47a1,1,0,0,0,0-2Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfd);
export default __webpack_public_path__ + "static/media/ofd.c7984385b9dcee5c574062a11eb5c926.svg";
export { ForwardRef as ReactComponent };